<template>
  <el-radio-group v-bind="$attrs"
                  v-on="$listeners"
                  style="display: flex; align-items: center">
    <el-radio v-for="option of options" :label="option.id" :key="option.id" style="width: 60px">
      {{option.name}}
    </el-radio>
  </el-radio-group>
</template>

<script>
  export default {
    name: 'DamageDegreeSelect',
    props: {
      sheetMetal: Boolean
    },
    created () {
      this.$store.dispatch('data/kvList', this.sheetMetal ? 'SheetMetalDamageDegree' : 'PaintDamageDegree')
    },
    computed: {
      options () {
        const options = []
        for (const item of this.degreeList || []) {
          options.push(item)
        }
        return options
      },
      degreeList () {
        return this.sheetMetal ? this.$store.state.data.SheetMetalDamageDegree : this.$store.state.data.PaintDamageDegree
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ {
    .el-radio__label {
      padding: 0;
    }

    .el-radio {
      margin: 0;
    }
  }
</style>
